import { Injectable } from '@angular/core';
import { ILocalNotification, LocalNotifications } from '@awesome-cordova-plugins/local-notifications/ngx';

@Injectable({
  providedIn: 'root'
})
export class LocalNotificationService {
  constructor(private localNotifications: LocalNotifications) {
    this.localNotifications.setDefaults({
      led: { color: '#FF00FF', on: 500, off: 500 },
      color: '#FF6600',
      smallIcon: 'ic_logo_push_notification',
      vibrate: true,
      priority: -1,
      lockscreen: true
    });
  }

  cancelAll() {
    return this.localNotifications.cancelAll();
  }

  async cancelInRange(startId: number, endId: number) {
    const notifications = await this.localNotifications.getScheduledIds();
    const ids: number[] = notifications.filter((id) => id && id >= startId && id <= endId);

    if (ids.length > 0) {
      await this.localNotifications.cancel(ids).catch(() => {});
    }
  }

  async cancelAboveId(minId: number) {
    const notifications = await this.localNotifications.getScheduledIds();
    const ids: number[] = notifications.filter((id) => id && id >= minId);

    if (ids.length > 0) {
      await this.localNotifications.cancel(ids).catch(() => {});
    }
  }

  on(eventName: string) {
    return this.localNotifications.on(eventName);
  }

  schedule(options: ILocalNotification | ILocalNotification[]) {
    try {
      this.localNotifications.schedule(options);
    } catch (e) {
      console.error(e);
    }
  }
}
